import { atom } from "jotai";
import useHttp from "../hooks/useHttp";
import { getZipFromResponce } from "../utils/getZipFromResponse";

export const productsInfoAtom = atom(null);
export const productsLoadingStatusAtom = atom("idle");
export const filtersLoadingStatusAtom = atom("loading");
export const filterInfoAtom = atom(null);
export const periodAtom = atom("3M");
export const periodChangeFlagAtom = atom(false);
export const selectedFiltersAtom = atom({
  bw: [],
  vid: [],
  brnd: [],
  sf: [1,2],
  bullet_type_s: [],
  bt: [],
  shell_length: [],
  mt: [],
  rpb: [],
});

export const fetchProductsAtom = atom(null, async (get, set, query) => {
  set(productsLoadingStatusAtom, "loading");
  set(filtersLoadingStatusAtom, "loading");
  const { getPriceHistory } = useHttp();
  getPriceHistory(query.includes("period") ? query : `${query}&period=3M`)
    .then((response) => {
      set(productsInfoAtom, response.response);
      set(filterInfoAtom, response.facets);
      getZipFromResponce(response.ip_response.ip_data.zip);
    })
    .finally(() => {
      set(productsLoadingStatusAtom, "idle");
      set(filtersLoadingStatusAtom, "idle");
    });
});
